import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Pagination } from "../../../../common/pagination";
import ModernPagination from "../../../../common/pagination/ModernPagination";
import Heading from '../../../../common/element/Heading';
import ClientInput from "../../../../common/element/Input/clientInput";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../redux/Admin/breadcrumbsSlice";
import { useDispatch, useSelector } from 'react-redux';
import ScienceOfSelfList from './ScienceOfSelf';
import AddEditIndividual from './AddEdit';
import { getScienceOfSelfList } from '../../../../redux/ScienceOfSelf/Scienceofselfslice';
import { selectScienceOfSelfList, selectScienceOfSelfListTotal, selectScienceOfSelfListLoading } from '../../../../redux/ScienceOfSelf/Scienceofselfselectors';

const ScienceOfSelf = () => {
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);

  const scienceList = useSelector(selectScienceOfSelfList);
  const totalCount = useSelector(selectScienceOfSelfListTotal);
  const loading = useSelector(selectScienceOfSelfListLoading);
  console.log(scienceList, "scienceList")
  const [getFilterData, SetFilterData] = useState({
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: "",
  });

  // Calculate total pages
  const totalPages = Math.ceil(totalCount / filterlimit);

  // Search Data
  const handleSearch = (e) => {
    SetFilterData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value.trim(),
      };
    });
    setfilterpage(1); // Reset to first page on search
  };

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Science of Self",
          url: "/scienceOfSelf",
          home: "/dashboard",
        },
      ])
    );
  }, [dispatch]);

  // Fetch Data
  const fetchData = useCallback(() => {
    dispatch(getScienceOfSelfList({
      page: filterpage,
      limit: filterlimit,
      search: getFilterData.search
    }));
  }, [dispatch, filterpage, filterlimit, getFilterData.search]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const inputchangehandler = useCallback(debounce(handleSearch), []);

  const handlePageChange = (page) => {
    setfilterpage(page);
  };

  return (
    <React.Fragment>
      <div>
        <p className="text-gray-600 my-3"></p>
      </div>

      <div className="flex justify-between mb-5">
        <div className="w-80 h-10 text-start">
          <Heading>Science of Self</Heading>
        </div>

        <div className="flex gap-2">
          <BtnPrimary
            onClick={() => setDialogOpen(true)}
            className="h-9 flex items-center justify-center gap-1"
            style={{ backgroundColor: '#FF8E1C', borderColor: '#FF8E1C' }}
          >
            Add Individual
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.712 4.167v11.666M4.878 10h11.667"
                stroke="#fff"
                strokeWidth="1.667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </BtnPrimary>
        </div>
      </div>

      <div className="flex justify-end mb-4">
        <div className="input-wrapper">
          <div className="input-suffix-start left-3.5">
            <img
              src="/assets/icons-svg/search-lg.svg"
              alt=""
              className="h-5"
            />
          </div>
          <ClientInput
            type="text"
            className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Search"
            inputchangehandler={inputchangehandler}
            name={"search"}
          />
        </div>
      </div>

      <ScienceOfSelfList sampleData={scienceList} loading={loading} onRefresh={fetchData} />

      <AddEditIndividual
        dialogOpen={dialogOpen}
        onDialogClose={() => {
          setDialogOpen(false);
          fetchData(); // Refresh list on close (if added/updated)
        }}
      />

      <div className="flex justify-between items-center mt-3">
        {/* Left side - Pagination info */}
        <Pagination
          totalCount={totalCount}
          pageNumber={filterpage}
          displayPage={scienceList?.length}
          UpdatePageLimit={setfilterlimit}
          UpdatePage={setfilterpage}
        />

        {/* Right side - Modern Pagination Controls */}
        {totalCount > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default ScienceOfSelf;